import React from 'react';
import api from '../../../../Api';

export default function useRatingsEditor(sku) {
	const [isLoading, setIsLoading] = React.useState(true);
	const [assessments, setAssessments] = React.useState([]);

	React.useEffect(() => {
		let request;

		if (!isLoading) return;

		const buildAssessments = assessments => {
			return assessments.map(a => ({
				id: a.id,
				name: a.name,
				value: a.value,
			}));
		};

		const fetchAssessments = async () => {
			const endpoint = `/api/me/assessments/products/${sku}`;
			request = api.cancelableGet(endpoint);

			const assessments = await request.promise;

			if (Array.isArray(assessments)) {
				setAssessments(buildAssessments(assessments));
				setIsLoading(false);
			} else {
				setAssessments(() => {
					throw new Error('Failed to fetch assessments');
				});
			}
		};

		fetchAssessments();

		return () => {
			api.revoke(request);
		};
	}, [sku]);

	const getRating = ratingType => {
		const rating = assessments.find(a => a.id === ratingType);
		if (rating) return rating;
		return {};
	};

	const ratingExists = ratingType => {
		const rating = getRating(ratingType);
		return Number(rating.value) > -1;
	};

	const updateRating = assessment => {
		const nextAssessments = assessments.map(a => {
			if (a.id === assessment.id) {
				return assessment;
			}
			return a;
		});
		setAssessments(nextAssessments);
	};

	const clear = () => {
		setAssessments([]);
	};

	return {
		get: getRating,
		update: updateRating,
		exists: ratingExists,
		isLoading: () => isLoading,
		getAll: () => assessments,
		clear,
	};
}
